import { t } from '@lingui/core/macro';
import { createLazyRoute } from '@tanstack/react-router';
import { ErrorPageContainer } from 'components/ErrorPageContainer';

const Page404 = () => {
  return (
    <ErrorPageContainer
      title={t`404 Page non trouvée`}
      subtitle={t`Désolé, nous n’avons pas trouvé la page que vous recherchez. Assurez-vous de vérifier l’orthographe de l’URL.`}
      buttonOptions={{ children: t`Revenir à l’accueil`, to: '/' }}
    />
  );
};

export default Page404;

export const Route = createLazyRoute('/404')({
  component: Page404,
});
